import MobileApp from "./screens/MobileApp";

export default MobileApp;
